export default __webpack_public_path__ + "static/media/leader_notes.35c16ac1.pdf";